export default {
    BILLABILITY_READ: { name: 'BILLABILITY_READ' },
    BILLABILITY_UPDATE: { name: 'BILLABILITY_UPDATE' },
    BILLING_ID_READ: { name: 'BILLING_ID_READ' },
    BILLING_ID_UPDATE: { name: 'BILLING_ID_UPDATE' },
    PAYLUDD_BETA_TEST: { name: 'PAYLUDD_BETA_TEST' },
    TEST_BOMO_BETA: { name: 'TEST_BOMO_BETA' },
    DASHBOARD_ACCESS: { name: 'DASHBOARD_ACCESS' }
};